module.exports = __webpack_public_path__ + "static/media/user-photoPurple.42b5f366.svg";